const ErrorSvg = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20.7723 14.0008C19.8793 17.9186 16.4983 20.7704 12.486 20.9901C8.47368 21.2098 4.80148 18.7442 3.48606 14.9473C2.17064 11.1504 3.53047 6.94142 6.81875 4.63187C10.107 2.32231 14.5277 2.4713 17.653 4.99702"
      stroke="#CE212B"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M21.0042 8L18.0029 10.9972"
      stroke="#CE212B"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.0049 8L21.0021 11.0013"
      stroke="#CE212B"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.0002 11.6688V8.39844"
      stroke="#CE212B"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.0002 15.2815C11.9574 15.2815 11.9164 15.2987 11.8863 15.3291C11.8562 15.3596 11.8396 15.4008 11.8401 15.4436C11.8417 15.5313 11.9125 15.6021 12.0002 15.6037C12.0897 15.6037 12.1623 15.5311 12.1623 15.4416C12.1623 15.3521 12.0897 15.2795 12.0002 15.2795"
      stroke="#CE212B"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export default ErrorSvg;
